import type { Task } from "shared-core/types/task";
import type {
  AutomateResponse,
  DeviceTaskAutomationService,
  UnlistenScanProgress,
} from "../types/device-task-automation-service.ts";

class NoopDeviceService implements DeviceTaskAutomationService {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  automate(_taskId: number, _taskReference: string): Promise<AutomateResponse> {
    return Promise.resolve({});
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onTaskCompleted(_task: Task): Promise<void> {
    // Default implementation: do nothing
    return Promise.resolve();
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  supportsAutomation(_taskType: string): boolean {
    return false;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  automationUnavailableReasonKey(_taskType: string): string | null {
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isDeviceVerified(_taskReference: string): boolean {
    return false;
  }

  getAgentOS(): string | null {
    return null;
  }

  syncTaskStatus(): Promise<void> {
    return Promise.resolve();
  }

  triggerBackup(): Promise<void> {
    return Promise.resolve();
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  scanBackupSources(_scanId: string): Promise<null> {
    return Promise.resolve(null);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  scanDirectory(_path: string): Promise<null> {
    return Promise.resolve(null);
  }

  saveDirectorySelections(): Promise<boolean> {
    return Promise.resolve(false);
  }

  onScanProgress(): Promise<UnlistenScanProgress> {
    return Promise.resolve(() => {});
  }
}

let deviceService: DeviceTaskAutomationService = new NoopDeviceService();

export function useDeviceService(): DeviceTaskAutomationService {
  return deviceService;
}

export function setDeviceService(service: DeviceTaskAutomationService): void {
  deviceService = service;
}
